import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ResourcesPage = lazy(() => import('~/features/platform/pages/resources-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/resources')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ResourcesPage />
    </Suspense>
  ),
});
